import React from 'react';
import { motion } from 'framer-motion';

const LogoTicker = () => {
  const logos = [
    { name: 'Google', symbol: 'Google' },
    { name: 'Netflix', symbol: 'Netflix' },
    { name: 'Slack', symbol: 'Slack' },
    { name: 'Stripe', symbol: 'Stripe' },
    { name: 'Spotify', symbol: 'Spotify' },
    { name: 'Figma', symbol: 'Figma' },
    { name: 'Cisco', symbol: 'Cisco' },
    { name: 'Samsung', symbol: 'Samsung' }
  ];

  // Repeat twice for infinite seamless scroll
  const scrollLogos = [...logos, ...logos];

  return (
    <div className="w-100 overflow-hidden py-4 border-top border-bottom" style={{ borderColor: 'rgba(255, 255, 255, 0.05)', background: '#000' }}>
      <div className="d-flex" style={{ width: 'max-content' }}>
        <motion.div
          animate={{ x: [0, -1000] }}
          transition={{
            repeat: Infinity,
            ease: 'linear',
            duration: 20
          }}
          className="d-flex align-items-center gap-5 px-3"
        >
          {scrollLogos.map((logo, idx) => (
            <div
              key={idx}
              className="d-flex align-items-center justify-content-center text-uppercase font-bold tracking-widest text-muted"
              style={{
                fontSize: '1.25rem',
                minWidth: '150px',
                opacity: 0.4,
                letterSpacing: '0.15em',
                color: '#fff',
                fontFamily: 'var(--font-sans)',
                fontWeight: 800
              }}
            >
              {logo.name}
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default LogoTicker;
